const buttonHandler = (formElement: any) => {
    const buttonElement =
        formElement.querySelector('input[type="submit"]') ||
        formElement.querySelector('button');
    const buttonText = buttonElement.value || buttonElement.textContent;
    const buttonLoadingText =
        buttonElement.getAttribute('data-wait') || buttonText;

    const setLoading = () => {
        buttonElement.disabled = true;
        buttonElement.value
            ? (buttonElement.value = buttonLoadingText)
            : (buttonElement.textContent = buttonLoadingText);
    };
    const setLoaded = () => {
        buttonElement.disabled = false;
        buttonElement.value
            ? (buttonElement.value = buttonText)
            : (buttonElement.textContent = buttonText);
    };

    return [setLoading, setLoaded];
};

export default buttonHandler;
